'use strict';

function GetErrorMessageFilter () {
    return deviceError => {
        if(!deviceError) return '';
        if(!deviceError.has_error)                           return '正常稼働中';
        if(deviceError.cloud_disconnected)                   return 'クラウドと未接続';
        if(deviceError.meter_off || deviceError.meter_fault) return 'スマートメーターから異常通知を受信';
        if(deviceError.meter_not_found)                      return 'スマートメーターが見つからない';
        if(deviceError.demand_fault)                         return 'データ取得失敗';
        if(deviceError.demand_level === 1)                   return 'デマンド警報発令中 (目標電力超過)'
        if(deviceError.demand_level === 2)                   return 'デマンド警報発令中 (限界電力超過)'
        if(deviceError.demand_level === 3)                   return 'デマンド警報発令中 (契約電力超過)'
    }
}

export default angular.module('leptonApp.GetErrorMessageFilter', [])
    .filter('getErrorMessage', [GetErrorMessageFilter])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/get_error_message/get_error_message.filter.js